import api from './api';

// Sprint 29.E + 29.G — service do painel pra LGPD cleanup ops.
//
// Endpoints (admin):
//   POST /admin/cleanup/preview — dry-run, COUNTS sem DELETE
//   POST /admin/cleanup/run     — DELETE real
//
// Schema do response identico (CleanupResult). Preview marca `mode: "preview"`.

export interface CleanupResult {
  events_deleted: number;
  sessions_deleted: number;
  sanctions_deleted: number;
  session_diagnostics_deleted: number;
  support_diagnostics_deleted: number;
  duration_ms: number;
  error_message: string;
  mode?: 'preview' | 'run';
}

export async function previewCleanup(): Promise<CleanupResult> {
  const resp = await api.post<CleanupResult>('/admin/cleanup/preview', {});
  return resp.data;
}

export async function runCleanup(): Promise<CleanupResult> {
  const resp = await api.post<CleanupResult>('/admin/cleanup/run', {});
  return resp.data;
}
